import { getRequest, postRequest } from "../utils/axios";

export const subscriptionService = {
  getLimits,
  getPlanConfig,
  createCheckoutSession,
  createBillingPortalSession,
  cancelSubscription,
  changePlan,
};

function getLimits(onSuccess, onError) {
  return getRequest(
    "/api/v1/user-config/",
    (response) => {
      if (onSuccess && response.data?.limits) {
        onSuccess(response.data.limits);
      } else if (onSuccess) {
        onSuccess(response.data?.limits || null);
      }
    },
    (error, response) => {
      if (onError) onError(error, response);
    }
  );
}

function getPlanConfig(onSuccess, onError) {
  return getRequest(
    "/api/v1/plans/",
    (response) => {
      if (onSuccess) {
        onSuccess({
          plans: response.data?.plans || {},
          order: response.data?.order || [],
          scout: response.data?.scout || null,
          trial_days: response.data?.trial_days,
        });
      }
    },
    (error, response) => {
      if (onError) onError(error, response);
    }
  );
}

function createCheckoutSession(orderType, billingCycle, paths, onSuccess, onError) {
  const payload = { order_type: orderType, billing_cycle: billingCycle };
  if (paths?.returnPath) payload.return_path = paths.returnPath;
  if (paths?.successPath) payload.success_path = paths.successPath;

  return postRequest(
    "/api/v1/billing/checkout/",
    payload,
    (response) => {
      if (onSuccess) onSuccess(response.data);
    },
    (error, response) => {
      if (onError) onError(error, response);
    }
  );
}

function createBillingPortalSession(onSuccess, onError) {
  return postRequest(
    "/api/v1/billing/portal/",
    {},
    (response) => {
      if (onSuccess) onSuccess(response.data);
    },
    (error, response) => {
      if (onError) onError(error, response);
    }
  );
}

function changePlan(orderType, billingCycle, onSuccess, onError) {
  return postRequest(
    "/api/v1/billing/change-plan/",
    { order_type: orderType, billing_cycle: billingCycle },
    (response) => {
      if (onSuccess) onSuccess(response.data);
    },
    (error, response) => {
      if (onError) onError(error, response);
    }
  );
}

function cancelSubscription(data, onSuccess, onError) {
  return postRequest(
    "/api/v1/billing/cancel/",
    data,
    (response) => {
      if (onSuccess) onSuccess(response.data);
    },
    (error, response) => {
      if (onError) onError(error, response);
    }
  );
}
